export { InputFields, type InputFieldsProps } from "./input-fields";
